export default __webpack_public_path__ + "static/media/glitch28.21e1ef0f.png";